import {Directive, ElementRef, HostBinding, OnDestroy, OnInit} from '@angular/core';
import {MASTER_MEALS_ONLY} from '../config/master-meals-only';

@Directive({
    selector: '[appMasterLock]'
})
export class MasterLockDirective implements OnInit, OnDestroy {
    private readonly blockEvent = (event: Event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
    };

    constructor(private readonly elementRef: ElementRef<HTMLElement>) {
    }

    @HostBinding('class.master-locked')
    get locked(): boolean {
        return MASTER_MEALS_ONLY;
    }

    @HostBinding('attr.aria-disabled')
    get ariaDisabled(): string | null {
        return MASTER_MEALS_ONLY ? 'true' : null;
    }

    @HostBinding('attr.title')
    get lockedTitle(): string | null {
        return MASTER_MEALS_ONLY ? 'Временно недостъпно' : null;
    }

    @HostBinding('attr.disabled')
    get disabled(): string | null {
        if (!MASTER_MEALS_ONLY || this.elementRef.nativeElement.tagName !== 'BUTTON') {
            return null;
        }

        return '';
    }

    ngOnInit() {
        if (!MASTER_MEALS_ONLY) {
            return;
        }

        this.elementRef.nativeElement.addEventListener('click', this.blockEvent, true);
    }

    ngOnDestroy() {
        this.elementRef.nativeElement.removeEventListener('click', this.blockEvent, true);
    }
}
